import { render, staticRenderFns } from "./CourseImageUploader.vue?vue&type=template&id=bc217070&scoped=true"
import script from "./CourseImageUploader.vue?vue&type=script&lang=js"
export * from "./CourseImageUploader.vue?vue&type=script&lang=js"
import style0 from "./CourseImageUploader.vue?vue&type=style&index=0&id=bc217070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../edeone/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc217070",
  null
  
)

export default component.exports